<template>
    <v-row justify="center">
        <v-dialog :disabled="loading" max-width="500px" persistent value="true">
            <v-card>
                <v-card-title class="blue">
                    <v-icon :disabled="loading" class="pa-1 mr-1" color="deep-orange lighten-1">fas fa-user-edit
                    </v-icon>
                    <span class="headline"> Kunden bearbeiten</span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-form class="px-3" ref="form">
                            <v-row>
                                <v-col class="my-0 py-0" cols="12">
                                    <v-text-field :disabled="loading" :rules="inputRules" class="my-0 py-0"
                                                  label="Email" required
                                                  v-model="localCustomer.Email"></v-text-field>
                                </v-col>
                                <v-col class="my-0 py-0" cols="12">
                                    <v-text-field :disabled="loading" :rules="inputRules" class="my-0 py-0"
                                                  label="Ansprechpartner"
                                                  required v-model="localCustomer.AP"></v-text-field>
                                </v-col>


                                <v-col class="my-0 py-0" cols="12">
                                    <v-text-field :disabled="loading" :rules="inputRules" class="my-0 py-0"
                                                  label="Firma"
                                                  required v-model="localCustomer.Firma"></v-text-field>
                                </v-col>

                                <v-col class="my-0 py-0" cols="12">
                                    <v-text-field :disabled="loading" :rules="inputRules" class="my-0 py-0"
                                                  label="Strasse"
                                                  required v-model="localCustomer.Strasse"></v-text-field>
                                </v-col>

                                <v-col class="my-0 py-0" cols="12">
                                    <v-text-field :disabled="loading" :rules="inputRules" class="my-0 py-0"
                                                  label="PLZ"
                                                  required v-model="localCustomer.PLZ"></v-text-field>
                                </v-col>

                                <v-col class="my-0 py-0" cols="12">
                                    <v-text-field :disabled="loading" :rules="inputRules" class="my-0 py-0"
                                                  label="Ort"
                                                  required v-model="localCustomer.Ort"></v-text-field>
                                </v-col>

                                <v-col class="my-0 py-0" cols="12">
                                    <v-text-field :disabled="loading" :rules="inputRules" class="my-0 py-0"
                                                  label="Land"
                                                  required v-model="localCustomer.Land"></v-text-field>
                                </v-col>
                                <v-col class="my-0 py-0" cols="12">
                                    <v-text-field :disabled="loading" class="my-0 py-0"
                                                  label="Telefon"
                                                  v-model="localCustomer.Telefon"></v-text-field>
                                </v-col>



                                <v-col class="my-0 py-0" cols="12">
                                    <v-textarea :disabled="loading" class="my-0 py-0"
                                                label="Kommentar" v-model="localCustomer.Kommentar"></v-textarea>
                                </v-col>

                            </v-row>
                        </v-form>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn :disabled="loading" @click="showPopup.show = false" color="blue darken-1" text>Schließen
                    </v-btn>
                    <v-btn :loading="loading" @click="submit" color="green darken-1" text>
                        Speichern
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>

    import {HTTP} from "../http";
    import {EventBus} from "../eventbus";


    export default {
        props: {
            showPopup: Object,
            customer: Object,
        },
        data() {
            return {
                localCustomer:
                    {
                        CustomerID: this.customer.CustomerID,
                        Email: this.customer.Email,
                        AP: this.customer.AP,
                        Firma: this.customer.Firma,
                        Strasse: this.customer.Strasse,
                        PLZ: this.customer.PLZ,
                        Ort: this.customer.Ort,
                        Land: this.customer.Land,
                        Telefon: this.customer.Telefon,
                        Kommentar: this.customer.Kommentar
                    },
                inputRules: [
                    v => !!v || 'Darf nicht leer sein'
                ],
                loading: false,
            }
        },
        methods: {
            submit() {
                if (this.$refs.form.validate()) {
                    this.loading = true;
                    HTTP.post("api/Customer", this.localCustomer).then(() => {
                        this.loading = false;
                        EventBus.$emit('reload');
                        this.showPopup.show = false
                    }).catch(() => {
                        this.loading = false;
                    })
                }

            }
        }
    }
</script>
